import React, { useState, useEffect } from 'react'
import { Grid, GridColumn } from 'semantic-ui-react'
import BrandWebSurveyLivePreview from 'components/BrandWebSurveyLivePreview'
import { getPreviewStyle } from './utils'
import constants from 'config/constants'
import { convertUrlToBase64 } from 'pages/Onboarding/utils'

export default function BrandOnboardingPreview({ brand }) {
  const [logo, setLogo] = useState('')
  const { logoObject, backgroundColor, backgroundImage, accentColor, font } = brand

  const previewStyle = getPreviewStyle(
    accentColor,
    backgroundColor,
    backgroundImage,
    '',
    font,
    logo
  )

  useEffect(() => {
    async function convertLogoToBase64() {
      const base64Logo = await convertUrlToBase64(logoObject.src)
      setLogo(base64Logo)
    }

    convertLogoToBase64()
  }, [logoObject.src])

  return (
    <React.Fragment>
      <GridColumn className="mobile hidden middle aligned onboarding-survey-preview">
        <Grid columns={1} container padded>
          <GridColumn>
            <BrandWebSurveyLivePreview
              previewStyle={previewStyle}
              previewURL={constants.onboardingPreviewSurveyUrl}
              showResetButton={false}
              showDeviceSwitcher={false}
            />
          </GridColumn>
        </Grid>
      </GridColumn>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/BrandSettings/BrandOnboardingPreview.js